import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { endCurrentOOOSegment } from '../../working-hours/utils/outOfOfficeUtils';
import { useOutOfOfficeHours } from '../../working-hours/hooks/useOutOfOfficeHours';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
export const EndOutOfOfficePrompt = ({
  userId,
  isViewingSelf,
  onConfirm,
  onReject
}) => {
  const {
    outOfOfficeHours,
    currentSegment,
    updateOutOfOfficeHours,
    isLoadingOOOHours
  } = useOutOfOfficeHours(userId, {
    isViewingSelf
  });
  if (isLoadingOOOHours) {
    return /*#__PURE__*/_jsx(UILoadingOverlay, {
      layout: "centered"
    });
  }
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    "data-test-id": "selenium-agent-status-confirm-modal",
    width: 500,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.endOutOfOfficePrompt.title"
    }),
    description: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.endOutOfOfficePrompt.description"
      })
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.endOutOfOfficePrompt.confirm"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.endOutOfOfficePrompt.cancel"
    }),
    onConfirm: () => {
      if (outOfOfficeHours && currentSegment) {
        updateOutOfOfficeHours(endCurrentOOOSegment(outOfOfficeHours));
      }
      onConfirm();
    },
    onReject: onReject
  });
};
EndOutOfOfficePrompt.displayName = 'EndOutOfOfficePrompt';